<template>
  <div class="bp-pagename">
    <h3>{{ $t(`user_pages.${pageName}`) }}</h3>
    <div class="bp-previous_page" @click="showScreen('missions')">
      <i class="icon icon-arrow-big"></i>
      <span>{{ $t(`user_pages.go_back`) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageName",

  props: {
    pageName: String,
  },

  methods: {
    showScreen(screen = "missions") {
      this.$store.commit("global/writeCurScreen", screen);
    },
  },
};
</script>
